import utils from '../utils'
import cnf from './src/theme'

let global = window || {};

var ZJTheme = function(opts) {
    this.extend(opts || {})
}

ZJTheme.prototype.extend = function() {
    return utils.extend.apply(this, [this, ...arguments])
}

// 参数：
//   key - 待读取的配置的 Key
//   def - 当配置项不存在时的默认值
ZJTheme.prototype.getValue = function(key, def) {
    let value = utils.selectJSON(this, key);
    if (typeof value !== 'undefined')
        return value;
    return def;
}

// 加载皮肤
ZJTheme.prototype.load = function(opts) {
    var that = this;
    opts = opts || {};
    return new Promise(function (resolve, reject) {
        try {
            that.extend( global.$theme || {});
            that.extend( opts.theme || {});
            global.$theme = that;
            resolve(that);
        }
        catch (e) {
            reject(e);
        }
    })
}

// 切换皮肤:
//   path - 皮肤路径
ZJTheme.prototype.changeTo = function(path) {
    return new Promise(function (resolve, reject) {
        try {
            this.extend({
                path: path
            })
            resolve(this)
        }
        catch (e) {
            reject(e)
        }
    })
}

ZJTheme.install = function(Vue) {
    // 切换为响应式扩展
    ZJTheme.prototype.extend = function() {
        return Vue.reactiveExtend.apply(this, [this, ...arguments])
    }

    ZJTheme.current = new ZJTheme(cnf);

    // 混入主题
    Vue.mixin({
        data() {
            return {
                theme: ZJTheme.current
            }
        },
        methods: {
            THM(key,def) { return this.theme.getValue(key, def) }
        }
    })

}

export default ZJTheme